import { render } from "./simpeg-pensiun-list-remote.vue?vue&type=template&id=5586a00a"
import script from "./simpeg-pensiun-list-remote.vue?vue&type=script&lang=js"
export * from "./simpeg-pensiun-list-remote.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__